const defaultState = {
    countries: {
        'Bulgaria': 'Bulgaria',
    },
    curatedTags: {},
}

export const COUNTRIES_UPDATED = 'COUNTRIES_UPDATED'
export const countriesUpdated = countries => ({
    type: COUNTRIES_UPDATED,
    countries,
})
export const CURATED_TAGS_UPDATED = 'CURATED_TAGS_UPDATED'
export const curatedTagsUpdated = curatedTags => ({
    type: CURATED_TAGS_UPDATED,
    curatedTags: curatedTags || {},
})

export const reducerData = (state = defaultState, action) => {
    switch (action.type) {
        case COUNTRIES_UPDATED: {
            const { countries } = action
            return { ...state, countries }
        }
        case CURATED_TAGS_UPDATED: {
            const { curatedTags } = action
            return { ...state, curatedTags }
        }
        default:
            return state
    }
}
